<template>
    <v-snackbar
            :color="snackData.color"
            :timeout="this.timeout"
            v-model="snackData.isOpen"
            top
    >
        {{ this.snackData.text }}
    </v-snackbar>
</template>

<script>
    export default {
        name: "SnackGeneral",
        props:['snackData'],
        data(){
            return {
                timeout: 4000
            }
        },
        watch: {
            snackData() {
                console.log(this.snackData);
            }
        }
    }
</script>

<style scoped>

</style>
